<template>
	<section v-if="showSection" class="bg-gradient-to-b md:bg-gradient-to-t from-[#F3F7FD]" data-path="sectionsJobs">
		<AdaptiveContainer class="flex justify-between items-center">
			<BaseHeading
				type="h5"
				class="my-9 col-span-full relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
			>
				<template v-if="showFavCategoryTitle">
					{{ $t("recommendedJobs.title") }}
				</template>
				<template v-else>
					{{ $t("highlightedPartnersJobs.title") }}
				</template>
			</BaseHeading>
			<div class="text-sm hidden sm:flex">
				<NuxtLink :to="`/${$i18n.locale}/jobs`" type="gray" class="text-sm">
					{{ $t("allJobs") }}
					<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
				</NuxtLink>
			</div>
		</AdaptiveContainer>
		<CarouselJobs
			:slideWidth="320"
			:highlightedGold="true"
			@hide-section="showSection = false"
			@has-category-jobs="showFavCategoryTitle = true"
			bannerType="higlighted-company-jobs"
		></CarouselJobs>

		<div class="sm:hidden mb-6">
			<NuxtLink
				:to="`/${$i18n.locale}/jobs`"
				class="w-full flex justify-center items-center bg-dj-blue/5 text-sm text-dj-blue hover:bg-dj-blue/10 active:bg-dj-blue/10 max-w-[320px] mx-auto mb-4 p-3 rounded-normal"
			>
				{{ $t("allJobs") }}
				<span class="material-icons-outlined pl-2">arrow_forward</span>
			</NuxtLink>
		</div>
	</section>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";
export default defineComponent({
	name: "Jobs",
	setup() {
		const showSection = ref(true);
		const showFavCategoryTitle = ref(false);

		return {
			showSection,
			showFavCategoryTitle,
		};
	},
});
</script>
